module.exports = __webpack_public_path__ + "static/media/3iphones.ac121424.png";